import { useEffect, useState } from 'react'
import type { RefObject } from 'react'

// Tracks an element's height via ResizeObserver. Returns 0 until the
// element is mounted and the first observation lands.
export function useElementHeight(ref: RefObject<HTMLElement | null>): number {
  const [h, setH] = useState(0)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const ro = new ResizeObserver(() => {
      setH(el.getBoundingClientRect().height)
    })
    ro.observe(el)
    setH(el.getBoundingClientRect().height)
    return () => ro.disconnect()
  }, [ref])
  return h
}